import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

const saveCartToLocalStorage = (cartItems) => {
  localStorage.setItem("cart", JSON.stringify(cartItems));
};

const loadCartFromLocalStorage = () => {
  const cart = localStorage.getItem("cart");
  return cart ? JSON.parse(cart) : [];
};

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => loadCartFromLocalStorage());

  useEffect(() => {
    // Save to local storage whenever the cartItems state changes
    saveCartToLocalStorage(cartItems);
  }, [cartItems]);

  const addToCart = (item) => {
    setCartItems((prevItems) => [
      ...prevItems,
      {
        ...item,
        uid: cartItems.length + 1,
        quantity: 1,
        price: item.prices[0].unit_amount / 100,
      },
    ]);
  };

  const removeFromCart = (itemId) => {
    setCartItems((prevItems) => prevItems.filter((item) => item.uid !== itemId));
  };

  return <CartContext.Provider value={{ cartItems, addToCart, removeFromCart }}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
